<template>
  <div class="matchListPage">
    <Form layout="inline">
      <FormItem>
        <Input v-model="searchInfo.doctorId" placeholder="请输入查询ID"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="searchDoctorName">搜索</Button>
      </FormItem>
    </Form>
    <div class="tablePanel">
      <Table size="small" :columns="columns" :dataSource="tableData" :scroll="{ y: 400 }" border rowKey="id" :pagination="false" :customRow="customRow" :rowClassName="rowClassName"></Table>
    </div>
    <div class="pageWrapper">
      <Pagination v-model="currentPage" :total="totalPage" @change="changePage"></Pagination>
    </div>
    <div class="footer">
      <div>
        <Button size="large" @click="closeMatchDoctor">取消</Button>
        <Button size="large" @click="noDoctorMate">无匹配项</Button>
        <Button type="primary" size="large" @click="haveDoctorMate" :loading="haveDoctorMateLoading">匹配</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Input, Button, Table, Pagination } from 'ant-design-vue'
import { getQuickDoctorList } from '../../api/check'
import { getNameInitials } from '../../libs/utils'
export default {
  props: {
    matchDoctorId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Form,
    FormItem: Form.Item,
    Input,
    Button,
    Table,
    Pagination
  },
  data () {
    return {
      searchInfo: {
        doctorId: ''
      },
      columns: [
        {
          title: 'ID',
          customRender: (text, record) => {
            const initials = getNameInitials(record.real_name)
            return `${initials}_${record.id}`
          }
        },
        { title: '城市', dataIndex: 'city' },
        { title: '来源', dataIndex: 'agent_name' }
      ],
      tableData: [],
      currentPage: 1,
      pageNo: 1,
      pageSize: 10,
      totalPage: 0,
      doctorId: '',
      doctorInfo: {},
      haveDoctorMateLoading: false
    }
  },
  async mounted () {
    await this.getDoctorList()
  },
  methods: {
     // 选中某一条标蓝
    customRow (record) {
      return {
        on: {
          click: () => {
            this.doctorId = record.id
            this.doctorInfo = record
          }
        }
      }
    },
    rowClassName (record) {
      return record.id === this.doctorId ? 'clickRowStyle' : '';
    },
    async getDoctorList () {
      let params = {
        pageNumber: this.pageNo,
        pageSize: this.pageSize
      }
      const doctorId = String(this.searchInfo.doctorId || '').trim()
      if (doctorId) params.doctorId = Number(doctorId)
      let data = await getQuickDoctorList(params)
      if (data) {
        this.tableData = data.results
        this.totalPage = data.totalCount
      }
      this.handleChangedData()
    },
    handleChangedData () {
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i]
        if (this.matchDoctorId && this.matchDoctorId === item.id) {
          this.doctorId = this.matchDoctorId
          this.doctorInfo = this.tableData[i]
          break
        } else {
          this.doctorId = this.tableData[0].id
          this.doctorInfo = this.tableData[0]
        }
      }
    },
    // 分页
    async changePage (page) {
      this.pageNo = page
      await this.getDoctorList()
    },
     // 搜索按钮
    async searchDoctorName () {
      this.pageNo = 1
      this.currentPage = 1
      await this.getDoctorList()
    },
    // 无匹配项
    noDoctorMate () {
      this.$emit('noDoctorMate')
    },
    // 匹配到医生
    haveDoctorMate () {
      if (this.haveDoctorMateLoading) return false
      this.haveDoctorMateLoading = true
      setTimeout(() => {
        this.haveDoctorMateLoading = false
      }, 1000)
      this.$emit('haveDoctorMate', this.doctorInfo)
    },
    // 取消
    closeMatchDoctor () {
      this.$emit('closeMatchDoctor')
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.matchListPage{
  .clickRowStyle{
    background: @primaryColor;
    color: @baseColor;
    &:hover{
      td{
        background-color: @primaryColor !important;
        color: @baseColor !important;
      }
    }
  }
  .ant-table-tbody .ant-table-row {
    cursor: pointer;
  }
  .ant-modal-body{
    max-height: 600px;
  }
  .ant-table-header{
    margin-bottom: 0 !important;
  }
  .pageWrapper{
    margin-top:20px;
  }
  .footer{
    .modalFooter();
  }
}
@media screen and (max-width: 991px){
  .matchListPage{
    .ant-form{
      display: flex;
      .ant-row{
        margin-right: 10px !important;
        &:first-child{
          flex: 1;
        }
      }
    }
    .ant-table-body{
      td{
        min-width: 100px;
      }
    }
  }
}
</style>
